import styled from '@emotion/styled';

export const FullScreenTermsAndConditions = styled('div')`
  padding: 1.5rem 1rem;
`;
